import AgentMarginService from '@infrastructure/agentMargin.api'

const DEFAULT_MAX_AGE_MS = 60_000

export default {
  namespaced: true,
  state: () => ({
    marginPercentage: null,
    signedCount: 0,
    fetched: false,
    fetchedAt: null,
  }),
  mutations: {
    SET(state, { marginPercentage, signedCount }) {
      state.marginPercentage = marginPercentage
      state.signedCount = signedCount
      state.fetched = true
      state.fetchedAt = Date.now()
    },
    RESET(state) {
      state.marginPercentage = null
      state.signedCount = 0
      state.fetched = false
      state.fetchedAt = null
    },
  },
  actions: {
    async fetchIfStale(
      { state, commit },
      { maxAgeMs = DEFAULT_MAX_AGE_MS } = {}
    ) {
      if (
        state.fetched &&
        state.fetchedAt &&
        Date.now() - state.fetchedAt < maxAgeMs
      ) {
        return
      }
      try {
        const data = await AgentMarginService.getMonthlySummary()
        commit('SET', {
          marginPercentage: data?.marginPercentage ?? null,
          signedCount: data?.signedCount ?? 0,
        })
      } catch (e) {
        commit('SET', { marginPercentage: null, signedCount: 0 })
      }
    },
  },
  getters: {
    agentMonthlyMargin: (state) => ({
      marginPercentage: state.marginPercentage,
      signedCount: state.signedCount,
    }),
  },
}
